import { useEffect, useState } from 'react';

import { createNotification } from '../helpers';
import { NotificationState, SuccessProps } from '../index';

type UseSuccessProps = NotificationState & SuccessProps & {
  timeout?: number;
};

const useSuccessNotification = ({
  timeout,
  isPending,
  successTitle,
  notifications,
  successMessage,
  setNotifications
}: UseSuccessProps) => {
  const [prevPending, setPrevPending] = useState(false);

  useEffect(() => {
    setPrevPending(!!isPending);

    const hasMessages = successTitle || successMessage;
    const canCreateNotification = !isPending && prevPending;

    if (!canCreateNotification || !hasMessages) return;
    
    const newNotification = createNotification({
      timeout,
      notifications,
      setNotifications,
      type: 'success',
      title: successTitle,
      description: successMessage
    });
    const newNotifications = [...notifications, newNotification];

    setNotifications(newNotifications);
  }, [isPending]);
};

export default useSuccessNotification;
